import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../services/product';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-media-centerdetails',
  templateUrl: './media-centerdetails.component.html',
  styleUrls: ['./media-centerdetails.component.scss'],
})
export class MediaCenterdetailsComponent implements OnInit {
  images: any[];
  itemType: string;
  resultJson: any = [];
  videos: any = [];
  hiddenVideo: false;
  isGallery: boolean = false;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;
  displayVideoCustom: boolean;
  activeIndex: number = 0;
  gallery: any = [];
  bannerInfo: any = { bannerImage: null, bannerTitle: null, content: null };
  bannerImage: any;

  constructor(private productService: ProductService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      let mediatype = params['mediaType'];
      this.loadBannerContent();
      this.loadGalleryData(mediatype);
    });

    // this.images = [
    //   {
    //     previewImageSrc: 'assets/images/accom-thumb-1.jpg',
    //     thumbnailImageSrc: 'assets/images/accom-thumb-1.jpg',
    //     alt: 'Description for Image 11',
    //     title: 'Title 11',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/home-banner-2.jpg',
    //     thumbnailImageSrc: 'assets/images/home-banner-2.jpg',
    //     alt: 'Description for Image 15',
    //     title: 'Title 15',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/poster-whatdo-2.png',
    //     thumbnailImageSrc: 'assets/images/poster-whatdo-2.png',
    //     alt: 'Description for Image 2',
    //     title: 'Title 2',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/poster-whatdo-3.png',
    //     thumbnailImageSrc: 'assets/images/poster-whatdo-3.png',
    //     alt: 'Description for Image 3',
    //     title: 'Title 3',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/accom-thumb-2.jpg',
    //     thumbnailImageSrc: 'assets/images/accom-thumb-2.jpg',
    //     alt: 'Description for Image 12',
    //     title: 'Title 12',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/accom-thumb-3.jpg',
    //     thumbnailImageSrc: 'assets/images/accom-thumb-3.jpg',
    //     alt: 'Description for Image 13',
    //     title: 'Title 13',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/accom-thumb-4.jpg',
    //     thumbnailImageSrc: 'assets/images/accom-thumb-5.jpg',
    //     alt: 'Description for Image 14',
    //     title: 'Title 14',
    //   },
    //   {
    //     previewImageSrc: 'assets/images/home-banner-1.jpg',
    //     thumbnailImageSrc: 'assets/images/home-banner-1.jpg',
    //     alt: 'Description for Image 15',
    //     title: 'Title 15',
    //   },
    // ];
    // this.instaService.getImages().then((images) => {
    //   this.images = images;
    // });

    // this.route.queryParams.subscribe((params) => {
    //   this.itemType = params['itemType'];
    //   if(this.itemType.toLowerCase() === "highlights")
    //   {
    //     this.loadHighLights();
    //   }
    //   else if(this.itemType.toLowerCase() === "gallery")
    //   {
    //     this.loadGalleryData();
    //   }
    // });
  }
  loadImages() {
    this.isGallery = true;
    this.loadGalleryData('image');
  }
  loadVideos() {
    this.isGallery = true;
    this.loadGalleryData('video');
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  videoClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
  loadHighLights() {
    this.productService.getHighlightSmall().then((products) => {});
  }
  loadBannerContent() {
    this.productService.getMediaCenterBannerContent().then((bannerInfo) => {
      this.bannerInfo = bannerInfo;
      if (this.bannerInfo.bannerImage) {
        this.bannerImage = this.bannerInfo.bannerImage;
      } else {
        this.bannerImage = '../../../assets/images/NoImage.jpg';
      }
    });
  }

  loadGalleryData(mediaType: string) {
    //   this.productService.getMediaCenterGallery().subscribe((data)=> {
    //     if(data)
    //     {
    //        console.log('Crowdriff data',JSON.stringify(data));

    //     }
    //  })
    this.productService.getMediaCenterGallery(mediaType).then((data) => {
      if (data) {
        if (mediaType.toLocaleLowerCase().indexOf('image') != -1) {
          for (let i = 0; i < data.assets.length; i++) {
            this.resultJson.push({
              previewImageSrc: data.assets[i].thumbnail_fullscreen,
              thumbnailImageSrc: data.assets[i].thumbnail_embed,
            });
          }
          this.images = this.resultJson;
        } else {
          for (let i = 0; i < data.assets.length; i++) {
            this.videos.push({
              previewImageSrc: data.assets[i].image_fullscreen,
              thumbnailImageSrc: data.assets[i].thumbnail_embed,
              sopVideo: data.assets[i].video_standard.url,
            });
          }
        }
      }
    });
  }

  public sopVideoUrl: String;
  public sopAutoPlay = false;

  playVideo(id: any) {
    // this.hiddenVideo = false;
    // this.sopAutoPlay = true;
    // this.sopVideoUrl = id.sopVideo;
    // this.displayCustom = true;
    this.activeIndex = id;
    this.displayVideoCustom = true;
  }
}
